exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3tC-0YsJglDzJYHV8ZrYIC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.tVfyuS_jiFvspQsGMxT0E{-ms-flex-item-align:start;align-self:flex-start;color:var(--card-secondaryText)}html[dir] .tVfyuS_jiFvspQsGMxT0E{padding-top:1px}.oWXJipPfftqLJzt0RQkHo{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;max-width:calc(100% - 40px)}", ""]);
// Exports
exports.locals = {
	"assetIconAndInput": "_3tC-0YsJglDzJYHV8ZrYIC",
	"icon": "tVfyuS_jiFvspQsGMxT0E",
	"input": "oWXJipPfftqLJzt0RQkHo"
};